import { render, staticRenderFns } from "./DetailPatrol.vue?vue&type=template&id=4058a8d9&"
import script from "./DetailPatrol.vue?vue&type=script&lang=js&"
export * from "./DetailPatrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports